import React, { useState } from "react";
import { Box, TextField, Button, CircularProgress } from "@mui/material";
import axios from "../../../config/axiosConfig";

// Estado 5 (Entregado) de una OT de Mantenimiento: espejo de la rama Guardar de
// observacion1.php del sistema viejo — a diferencia de Adición/Devolución, Mantenimiento
// NO pasa por "Concluido" con firma (Nombre/C.I./Fecha/Hora); de "Entregado" salta
// directo a "Finalizado" con solo una observación (decisión confirmada: se replica el
// cierre simple del sistema viejo tal cual, sin unificar con el genérico de firma).
const FinalizarMantenimientoOT = ({ cod_ot, onFinalizado }) => {
  const [observacion, setObservacion] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  const finalizar = async () => {
    if (!window.confirm("¿Finalizar este Mantenimiento? Quedará como Finalizado.")) return;
    setGuardando(true);
    setError("");

    // Se abre la pestaña ya (en blanco) antes de cualquier await, en el mismo gesto de
    // click, para que el navegador no la bloquee como popup.
    const pdfWindow = window.open("", "_blank");
    if (pdfWindow) {
      pdfWindow.opener = null;
      pdfWindow.document.title = "Generando Nota de Mantenimiento...";
      pdfWindow.document.body.innerHTML =
        '<div style="font-family:Arial,sans-serif;padding:24px;color:#334155">Finalizando y generando la Nota de Mantenimiento...</div>';
    }

    try {
      const res = await axios.patch(`/api/ot-solicitudes/${cod_ot}/finalizar-mantenimiento`, { observacion });
      if (onFinalizado) onFinalizado(res.data);

      if (pdfWindow) {
        try {
          const { data } = await axios.get(`/api/ot-solicitudes/${cod_ot}/nota-mantenimiento.pdf`, { responseType: "blob" });
          const pdfUrl = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
          pdfWindow.location.replace(pdfUrl);
          setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
        } catch {
          pdfWindow.close();
        }
      }
    } catch (err) {
      if (pdfWindow) pdfWindow.close();
      setError(err?.response?.data?.error || "No se pudo finalizar el Mantenimiento.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Box sx={{ mt: 1 }}>
      {error && <Box sx={{ color: "error.main", fontSize: 13, mb: 1.5 }}>{error}</Box>}
      <TextField
        label="Observación"
        fullWidth
        multiline
        rows={3}
        value={observacion}
        onChange={(e) => setObservacion(e.target.value)}
        sx={{ mb: 2 }}
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" color="success" onClick={finalizar} disabled={guardando}>
          {guardando ? <CircularProgress size={20} color="inherit" /> : "Finalizar Mantenimiento"}
        </Button>
      </Box>
    </Box>
  );
};

export default FinalizarMantenimientoOT;
